module.exports = __webpack_public_path__ + "img/Pinjaman-Lunas.24b996d8.svg";